// 結果画面の出口（ボタン文言と遷移先）。
// 登録導線では結果からプランナー紹介説明へ直接進み、
// ホームから入った場合は来た場所へ戻す。
// ホームには「相性の良いプランナー」があるため、プランナーへの導線はそちらが担う。
interface ResultExit {
  label: string;
  path: string;
}

export const HOME_EXIT: ResultExit = { label: "ホームへ", path: "/mypage" };
export const COMPATIBILITY_AGENTS_EXIT: ResultExit = { label: "次へ", path: "/diagnosis_compatibility_agents/intro" };

export const buildResultExit = (fromHome: boolean): ResultExit => (fromHome ? HOME_EXIT : COMPATIBILITY_AGENTS_EXIT);
